import { routes } from './route/index'
import URL from '@/lib/url'

// 页面类型
interface PageType {
  name: string // 页面名称
  route: string // 页面路由
  pageId: string // 页面id
  level: number // 页面级别
  isAutoPV?: boolean // 控制zpmShow是否自动发送
}

// 路由meta类型
interface RouteMetaType {
  desc: string // 页面名称
  pageId: string // 页面id
  level: number // 页面级别
  isAutoPV?: boolean // 控制zpmShow是否自动发送
}

// 路由类型
interface RouteType {
  path: string // 路径
  name: string // 别名
  meta: RouteMetaType // 附加参数
  component: Function // 组件
}

const pageIdConfig: { routeList: PageType[] } = {
  // 需要统计数据的路由列表
  routeList: routes
    .filter((v: RouteType) => v?.meta && v?.meta?.pageId)
    .map((v: RouteType) => {
      const result: PageType = {
        name: v.name,
        route: v.path,
        pageId: v.meta.pageId,
        level: v.meta.level,
        isAutoPV: v.meta.isAutoPV
      }
      return result
    })
}

export const useRouteParams = () => {
  const currentRoute = routes.find((route: RouteType) => location.href.includes(route.path));
  if (!currentRoute) {
    return {};
  }
  const { useUrlParams } = currentRoute;
  if (useUrlParams) {
    const params = useUrlParams.reduce((obj, key) => {
      obj[key] = URL.getParam(key);
      return obj;
    }, {});
    return params;
  } else {
    return {};
  }
};

export default pageIdConfig
